import { API } from "@/plugins/Api";

import { Trans } from "@/plugins/Translation";

import router from "../router";

// POSTS

// Get latest posts from API
export const getLatestPosts = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/posts/latest`).then(
    async response => {
      // Commit to state
      commit("setLatestPosts", response.data.posts);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// Get individual post from API
export const getPost = ({ commit }, { slug }) => {
  return API.get(`${Trans.currentLanguage}/posts/${slug}`).then(
    async response => {
      // if there was an error,
      // redirect to 404
      if (response.data.error === true) {
        router.push({ name: "error" });
        return Promise.resolve();
      }

      commit("setPost", response.data.post);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// Get all posts from API
export const getPosts = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/posts/all`).then(async response => {
    let posts = response.data.posts;

    if (posts.length <= 0 || Object.keys(posts).length === 0) {
      return Promise.resolve();
    }

    // Map category slugs into filters array
    posts.map(post => {
      // if categories, map to filters
      // esle, set to empty string
      if (post.categories) {
        post["filters"] = post.categories.map(c => c.slug);
      } else {
        post["filters"] = "";
      }
    });
    // Commit to state
    commit("setPosts", posts);
    // Interacting with the store, see `localForage` API.
    const length = await API.cache.length();
    return Promise.resolve();
  });
};

// Get all categories from API
export const getCategories = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/posts/categories`).then(
    async response => {
      // Commit to state
      let data = {
        id: "all",
        name: "All",
        slug: "all"
      };

      // check if we have data
      if (Object.keys(response.data.categories).length > 0) {
        response.data.categories.unshift(data);
      }

      commit("setCategories", response.data.categories);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// FEATURES

// Get all  from API
export const getFeatures = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/features/all`).then(
    async response => {
      commit("setFeatures", response.data.features);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// FIGHTERS

// Get all  from API
export const getFighters = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/fighters/all`).then(
    async response => {
      let fighters = [];

      // check if we have data
      if (Object.keys(response.data.fighters).length > 0) {
        // Order a-z
        fighters = response.data.fighters.sort((a, b) => {
          // push coming soon fighters to end of array
          if (a.coming_soon < b.coming_soon) {
            return -1;
          }

          if (
            a.character_overview.class_order < b.character_overview.class_order
          ) {
            return -1;
          }
          if (
            a.character_overview.class_order > b.character_overview.class_order
          ) {
            return 1;
          }
          return 0;
        });
      }

      commit("setFighters", fighters);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// Get individual fighter from API
export const getFighter = ({ commit }, { slug }) => {
  return API.get(`${Trans.currentLanguage}/fighters/${slug}`).then(
    async response => {
      // if there was an error,
      // redirect to 404
      if (response.data.error === true) {
        router.push({ name: "error" });
        return Promise.resolve();
      }

      commit("setFighter", response.data.fighter);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// unset fighter from state
export const unsetFighter = ({ commit }) => {
  commit("setFighter", []);
  return Promise.resolve();
};

// WALLPAPERS

// Get all  from API
export const getWallpapers = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/wallpapers/all`).then(
    async response => {
      commit("setWallpapers", response.data.wallpapers);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// VIDEOS

// Get all  from API
export const getVideos = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/videos/all`).then(async response => {
    commit("setVideos", response.data.videos);
    // Interacting with the store, see `localForage` API.
    const length = await API.cache.length();
    return Promise.resolve();
  });
};

// DOWNLOADS

// Get all  from API
export const getDownloads = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/downloads/all`).then(
    async response => {
      commit("setDownloads", response.data.downloads);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// SCREENSHOTS

// Get all  from API
export const getScreenshots = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/screenshots/all`).then(
    async response => {
      commit("setScreenshots", response.data.screenshots);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// PAGES

// Homepage
export const getHomepage = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/pages/homepage`).then(
    async response => {
      commit("setHomepage", response.data.homepage);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// DMCAPolicy
export const getDMCAPolicypage = ({ commit }) => {
  return API.get(`${Trans.currentLanguage}/pages/dmca-policy`).then(
    async response => {
      commit("setDMCAPolicy", response.data.dmcapolicy);
      // Interacting with the store, see `localForage` API.
      const length = await API.cache.length();
      return Promise.resolve();
    }
  );
};

// USER

// Check user data
export const getUser = ({ commit }) => {
  return API.get(`/profile`).then(async response => {
    commit("setUser", response.data.user);
    // Interacting with the store, see `localForage` API.
    const length = await API.cache.length();
    return Promise.resolve();
  });
};

// Logout a user
export const unsetUser = ({ commit }) => {
  return API.get(`/logout`).then(async response => {
    commit("setUser", response.data.user);
    // Interacting with the store, see `localForage` API.
    const length = await API.cache.length();
    return Promise.resolve();
  });
};

// CODES

// Redeem a code
export const redeemCode = ({ commit }, { code }) => {
  return API.get(`/code/redeem/${code}`).then(async response => {
    // if success, commit code to user obj in state
    if (response.data.status === 200) {
      commit("setUserCode", code);
    }

    return Promise.resolve(response);
  });
};

// MEDIA

// get press kit url
// populate media categies array in state
export const getMediaCategories = ({ commit }) => {
  // define media categories
  let categories = [
    {
      id: 1,
      name: "All",
      slug: "all"
    },
    {
      id: 2,
      name: "Screenshots",
      slug: "screenshots"
    },
    {
      id: 3,
      name: "Wallpapers",
      slug: "wallpapers"
    },
    {
      id: 4,
      name: "Videos",
      slug: "videos"
    },
    {
      id: 6,
      name: "Downloads",
      slug: "downloads"
    },
    {
      id: 5,
      name: "Contact",
      slug: "contact",
      router: true
    }
  ];

  commit("setMediaCategories", categories);

  // get press kit url from cache
  // return API.get(`${Trans.currentLanguage}/pages/presskit`).then(async (response) => {

  //   // if no errors, push presskit url to array
  //   if(response.data.error === false) {
  //     let item = {...response.data.presskit, link: true}
  //     categories.push(item);
  //   }

  //   commit('setMediaCategories', categories)
  //   return Promise.resolve()
  // })
};

// SURVEY DATA

export const submitSurveyData = ({ commit }, data) => {
  // post survey data
  return API.post(`/survey/submit`, data).then(async response => {
    return Promise.resolve(response);
  });
};

// Cookie Policy
export const cookiePolicy = ({ commit }, data) => {
  commit("setCookiePolicy", data);
};



// WEBPACK FOOTER //
// ./src/store/actions.js